import React from 'react';
import FlowingMenu from '../ui/FlowingMenu';

// Wrap Workflow in React.memo for performance
const Workflow: React.FC = React.memo(() => {
  const workflowItems = [
    {
      link: "#discovery",
      text: "Discovery",
      image: "https://images.unsplash.com/photo-1551434678-e076c223a692?w=400&h=300&fit=crop"
    },
    {
      link: "#strategy",
      text: "Strategy",
      image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=300&fit=crop"
    },
    {
      link: "#design",
      text: "Design",
      image: "https://images.unsplash.com/photo-1561070791-2526d30994b5?w=400&h=300&fit=crop"
    },
    {
      link: "#development",
      text: "Development",
      image: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=400&h=300&fit=crop"
    },
    {
      link: "#launch",
      text: "Launch",
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=300&fit=crop"
    },
    {
      link: "#optimize",
      text: "Optimize",
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=300&fit=crop"
    }
  ];

  return (
    <section id="workflow" className="relative w-full bg-black min-h-screen" style={{ willChange: 'transform, opacity' }}>
      {/* FlowingMenu Container */}
      <div className="w-full h-screen" style={{ willChange: 'transform, opacity' }}>
        <FlowingMenu items={workflowItems} />
      </div>
    </section>
  );
});

export default Workflow; 